import API from '../apiCreate'
import type { ResponseKanbanSources } from '../types/crm/crm.types'
import {
  buildKanbanBoardQueryString,
  buildKanbanColumnItemsQueryString,
  KanbanApiFilters,
} from '@pages/Admin/KanbanCRM/api/kanban.api'
import {
  GetKanbanCardResponse,
  GetKanbanColumnItemsResponse,
  MoveKanbanCardResponse,
} from '@pages/Admin/KanbanCRM/store/kanban.types'

/** Канбан CRM: `/v1/crm-kanban/*`. */
export const crmKanbanApi = {
  getBoard: (params: {
    funnel_id: number
    filters?: KanbanApiFilters
    columns_limit?: number
    status_limits?: Record<number, number>
  }) => {
    const query = buildKanbanBoardQueryString(params)
    return API.get(`crm-kanban/board?${query}`)
  },

  moveCard: (params: {
    lead_funnel_id: number
    to_status_id: number
    sorting: number
  }) => API.patch<MoveKanbanCardResponse>(`crm-kanban/move-card`, params),

  getMoreColumnItems: (params: {
    funnel_id: number
    status_id: number
    cursor?: string | null
    limit?: number
    filters?: KanbanApiFilters
  }) => {
    const query = buildKanbanColumnItemsQueryString(params)
    return API.get<GetKanbanColumnItemsResponse>(
      `crm-kanban/column-items?${query}`,
    )
  },

  getSources: () => API.get<ResponseKanbanSources>('crm-kanban/sources'),

  getCard: (params: { lead_funnel_id: number }) =>
    API.get<GetKanbanCardResponse>(
      `crm-kanban/card?lead_funnel_id=${params.lead_funnel_id}`,
    ),
}
